import { SxProps } from "@mui/material";
import { colors } from "../../../../theme/palette";

interface StyleProps {
  variant: "list" | "grid" | "trending";
  currentLanguage?: string;
}

export const checkboxStyle: Record<string, SxProps> = {
  list: {
    position: "absolute",
    right: "0",
    top: "0",
  },
  trending: {
    position: "absolute",
    right: "0",
    top: "0",
  },
  grid: {
    position: "absolute",
    right: "0",
    top: "0",
  },
};

export const avatarStyle: Record<string, SxProps> = {
  list: {
    width: "72px",
    height: "72px",
  },
  trending: {
    width: "49px",
    height: "49px",
  },
  grid: {
    width: "56px",
    height: "56px",
  },
};

export const verificationIconStyle: Record<string, SxProps> = {
  grid: {
    top: "52px",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "10",
    position: "absolute",
  },
  trending: {
    top: "35px",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "10",
    position: "absolute",
  },
  list: {
    top: "72px",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "10",
    position: "absolute",
  },
};

export const getCardWrapperStyle = ({ variant }: StyleProps): SxProps => ({
  ...(variant === "list" && {
    position: "relative",
    display: "flex",
    columnGap: "20px",
    alignItems: "flex-start",
    padding: "7.5px 0",
  }),
  ...(variant === "grid" && {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    padding: "12px",
    width: "100%",
    minWidth: 0,
    backgroundColor: "#FFF",
    borderRadius: "8px",
    border: "1px solid #E7E7E7",
  }),
  ...(variant === "trending" && {
    position: "relative",
    display: "flex",
    gap: "10px",
    alignItems: "flex-start",
    paddingBottom: "17px",
    marginBottom: "17px",
    borderBottom: "1px solid #EAECF0",
  }),
});

export const getCardContentStyle = ({ variant }: StyleProps): SxProps => ({
  ...(variant === "list" && {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  }),
  ...(variant === "grid" && {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    width: "100%",
    minWidth: 0,
  }),
  ...(variant === "trending" && {
    display: "flex",
    flexDirection: "column",
    rowGap: "8px",
    flex: 1,
  }),
});

export const getFullNameStyle = ({ variant }: StyleProps): SxProps => ({
  textDecoration: "none",
  color: colors.dark1000,
  fontSize: "16px",
  fontWeight: variant === "grid" ? 700 : 600,
  lineHeight: "normal",
  maxWidth: variant === "grid" ? "80%" : "95%",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  cursor: "pointer",
  ...(variant === "grid" && {
    color: "var(--Dark---1000, #111)",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "12px",
  }),
});

export const fullNameWrapperStyle = ({ variant }: StyleProps): SxProps => ({
  display: "flex",
  columnGap: "3px",
  width: "100%",
  minWidth: 0,
  alignItems: "center",
  marginBottom: "5.5px",
  justifyContent: variant === "grid" ? "center" : "flex-start ",
  ...(variant === "grid" && { marginBottom: "0" }),
});

export const getTypographyStyles = ({ variant }: StyleProps) => ({
  roleClub: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    ...(variant === "grid" && {
      color: "var(--Dark---600, #707070)",
      fontFamily: "Montserrat",
      fontSize: "10px",
      fontWeight: 600,
      lineHeight: "normal",
      textAlign: "center",
    }),
  },
  mutualFollowersAndFriendsCount: {
    color: "var(--Dark---600, #707070)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    minHeight: "24px",
    ...(variant === "grid" && { textAlign: "center" }),
  },
  countryName: {
    color: "var(--Dark---600, #707070)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    ...(variant === "grid" && { textAlign: "center" }),
  },
});
